module.exports = __webpack_public_path__ + "media/images/icon_search_btn_new-b14dabf65e5d9f48a2ea8867e5651248.png";